import React, { useState } from "react";
import { Dropdown , DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap'


const ExternalDD = (props) => {
    var { 
        data, 
        onClick, 
        style, 
        right = false,
        direction = 'down',
        type
    } = props;

    var [ isOpen, setIsOpen ] = useState(false)
    const toggle = () => setIsOpen(!isOpen)

    return (
        <React.Fragment>
            <Dropdown isOpen={isOpen} toggle={toggle} 
                style={style} 
                direction={direction}
            >
                <DropdownToggle tag="div" className="">
                        {props.children}
                </DropdownToggle>
                <DropdownMenu right={right} className="dropdown-menu">
                    {(data !== undefined ?
                        data.map((o, i) => {
                            var iconClass
                            iconClass = type === 'checkbox' ? o.isSelected ? "far fa-check-square" : "far fa-square" 
                                    : type === 'radio' ? o.isSelected ? "far fa-dot-circle" : "far fa-circle"
                                    : null
                            if (o.type === 'checkbox') iconClass = o.isSelected ? "far fa-check-square" : "far fa-square"
                            return o.isDivider ? <DropdownItem  key={i} divider /> 
                            : <DropdownItem key={i}
                                toggle={type === 'checkbox' || o.type === 'checkbox' ? false: true} 
                                disabled={o.isDisabled ? true : false} className="dd-item" onClick={() => { onClick(o) }}
                                header={o.isHeader ? true : false}
                            >
                            {iconClass ? <i className={iconClass + " mg-r-4"}></i> : null}
                            {o.label}</DropdownItem>
                        })
                        : null)
                    }
                </DropdownMenu>
            </Dropdown >
        </React.Fragment>
    );
}

export default ExternalDD